<script setup lang="ts">
// Tela raiz da tab "Dados" do Minha Conta V2 (ENG-362).
// Só existe com o flag ligado; sem flag redireciona pro perfil antigo.
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: t('account.account_details'),
});

if (!isUserV2Enabled.value) {
  await navigateTo(localeLink('/user/profile'), { redirectCode: 302 });
}
</script>

<template>
  <UserV2ScreenDataMenu v-if="isUserV2Enabled" />
</template>
